import { BaseDto } from "@models/base/baseDto.model";

export class TipoMovimientoDto extends BaseDto{
    public resta!: boolean
    public editable!: boolean
    public esAnulable!: boolean
}
